export default {
  control: () => ({
    background: 'none',
    border: 'none',
    boxShadow: 'none',
    color: 'var(--theme-primary-link-color)',
    minHeight: 0,
    outline: 'none',
  }),
  indicatorsContainer: (defaultStyles) => ({
    ...defaultStyles,
    display: 'none',
  }),
  valueContainer: (defaultStyles) => ({
    ...defaultStyles,
    padding: 0,
  }),
  menu: (defaultStyles) => ({
    ...defaultStyles,
    zIndex: 3,
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: 'var(--theme-primary-link-color)',
  }),
  input: (defaultStyles) => ({
    ...defaultStyles,
    color: 'var(--theme-primary-link-color)',
    margin: 0,
    padding: 0,
  }),
  singleValue: (defaultStyles) => ({
    ...defaultStyles,
    color: 'var(--theme-primary-link-color)',
  }),
};
